import { ModalRegistry } from '../../context/ModalRegistry';
import { useModalContext } from '../../context/ModalContext';

const GeneralModal = () => {
  const { openModal, modalName } = useModalContext()
  const ModalComponent = ModalRegistry[modalName];
  
  return (
        <div>
          { openModal && 
            <ModalComponent />
          } 
        </div>
  )
}

export default GeneralModal;
